$(document).ready(function() {
    if(window.product_request) {
        setTimeout(function() {
            if(window.product_request.user_firstname && $('.hs-form-field input[name="firstname"]').length) {
                var user_firstname_input = $($('.hs-form-field input[name="firstname"]')[0]);
                user_firstname_input.val(window.product_request.user_firstname);
                console.log(user_firstname_input.val());
            }
            if(window.product_request.user_lastname && $('.hs-form-field input[name="lastname"]').length) {
                var user_lastname_input = $($('.hs-form-field input[name="lastname"]')[0]);
                user_lastname_input.val(window.product_request.user_lastname);
                console.log(user_lastname_input.val());
            }
            if(window.product_request.product_sku && $('.hs-form-field input[name="shop_artikel_nr"]').length) {
                var product_sku_input = $($('.hs-form-field input[name="shop_artikel_nr"]')[0]);
                product_sku_input.val(window.product_request.product_sku);
                console.log(product_sku_input.val());
            }
            if(window.product_request.product_url && $('.hs-form-field input[name="shop_url_deeplink"]').length) {
                var product_url_input = $($('.hs-form-field input[name="shop_url_deeplink"]')[0]);
                product_url_input.val(window.product_request.product_url);
                console.log(product_url_input.val());
            }
            if(window.product_request.product_name && $('.hs-form-field input[name="shop_produktname"]').length) {
                var product_name_input = $($('.hs-form-field input[name="shop_produktname"]')[0]);
                product_name_input.val(window.product_request.product_name);
                console.log(product_name_input.val());
            }
        },500);
    }
});

function onMutation(mutations) {
    const found = [];
    for (const { addedNodes } of mutations) {
        for (const node of addedNodes) {
            if (!node.tagName) continue; // not an element
            if (node.classList.contains('submitted-message')) {
                console.log('Hubspot Form submitted');
                var scrollDiv = node.offsetTop-100;
                window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
            }
        }
    }
}

let target = document.querySelector('.hbspt-form');
if(target) {
    const observer = new MutationObserver(onMutation);
    observer.observe(target, {
    childList: true,
    subtree: true,
    });
}